angular
    .module('sms')
    .controller('SmsSendDialogController', function ($uibModalInstance, data, SMS, toastr) {

        this.$onInit = () => {
            this.resource = data.resource
            this.subjectName = data.subjectName

            this.item = {
                phone: data.phone
            }
        }

        this.submit = () => {
            return SMS.sendMessage(this.item).$promise.then(() => {
                toastr.success("Wysłano")
                $uibModalInstance.close()
            })
        }

        this.close = () => $uibModalInstance.dismiss('cancel')
    })
